<script setup lang="ts">
import { Agency } from "@/services/account/types";
import { useAuthStore } from "@/store/useAuthStore";
import { ref } from "vue";
import { computed, onBeforeMount } from "vue";

type NameType = string | { name: string };
interface PropsInterface {
    main?: boolean;
    classes?: string;
    location?: NameType;
    showAgency?: boolean;
}

const props = withDefaults(defineProps<PropsInterface>(), {
    location: "/login",
    showAgency: true,
});

const logoURL = computed<string>(() => {
    get: return props.main
        ? "/images/tripCartLogoMain.svg"
        : "/images/tripCartLogo.svg";
});
// TravelSassLogo
const logoWidth = computed<number>(() => {
    return props.main ? 246 : 175;
});

const logoHeight = computed<number>(() => {
    return props.main ? 56 : 40;
});
const userAgency = ref<Agency | null>(null);
const authStore = useAuthStore();
onBeforeMount(() => {
    userAgency.value = authStore.user.agency;
});
</script>

<template>
    <h1 class="inline-flex items-center text-5xl" v-once>
        <router-link
            :to="props.location"
            :class="`inline-block ${props.classes}`"
            ><img
                :width="logoWidth"
                :height="logoHeight"
                class="mx-auto w-full"
                :src="logoURL"
                alt="site logo"
        /></router-link>
        <span
            v-if="userAgency && props.showAgency"
            class="ml-3 text-[12px] inline-flex leading-[18px] text-white items-center font-medium rounded-full py-0.5 px-1.5 bg-white/20"
            ><span class="w-2 h-2 mr-1 rounded-full bg-white"></span
            >{{ userAgency?.title }}</span
        >
    </h1>
</template>
